import qs from 'qs'
import { APP_TYPE, LOCAL_STORAGE_KEYS } from '@/lib/consts.js'

export function detectApplicationType () {
  const appType = getAppTypeFromQueryParams()
  if (isValidAppType(appType)) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.APP_APP_TYPE, appType)
  }
}

function getAppTypeFromQueryParams () {
  let params = qs.parse(window.location.search.substring(1))
  return params.appType?.toLowerCase()
}

function isValidAppType (appType) {
  return appType && [
    APP_TYPE.MOBILE,
    APP_TYPE.TABLET,
    APP_TYPE.PWA,
  ].includes(appType)
}
